import type { CheckboxV2Props } from '@withjoy/joykit';
import { CheckboxV2 } from '@withjoy/joykit';
import React from 'react';
import type { CatalogProductFilterAttribute } from '../../RefinementFacet.types';
import { StyledItemWrapper, StyledSkeletonFilterItemContainer, styles } from './ListCheckboxRow.styles';
import { SkeletonText, SkeletonThumbnail } from '@shared/components/Skeleton';

export interface FilterItemVo
  extends Readonly<{
      disabled?: boolean;
    }>,
    CatalogProductFilterAttribute {}

interface ListRowProps<T extends FilterItemVo>
  extends Readonly<{
    item: T;
    handleSelectedChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  }> {}

const checkboxOverrides: CheckboxV2Props['overrides'] = {
  Root: { props: { ...styles.checkboxRootStyles, 'data-group': '' } },
  Label: { props: { typographyVariant: 'button1' } },
};

export const ListCheckboxRow = React.memo(<T extends FilterItemVo>({ item, handleSelectedChange }: ListRowProps<T>) => (
  <StyledItemWrapper>
    <CheckboxV2
      overrides={{
        ...checkboxOverrides,
        Input: { props: { ['data-item-id']: item.compositeCode } },
      }}
      isChecked={item.isActive}
      onChange={handleSelectedChange}
      disabled={item.disabled}
    >
      {item.value.title}
      {item.matchingItemsCount && ` (${item.matchingItemsCount})`}
    </CheckboxV2>
  </StyledItemWrapper>
));

export const ListCheckboxRowSkeleton = () => {
  return (
    <StyledSkeletonFilterItemContainer __css={styles.filterItemContainer}>
      <SkeletonThumbnail
        variant="square"
        width={'20px'}
        height={'20px'}
      />
      <SkeletonText
        rows={1}
        marginLeft={'16px'}
        skeletonHeight={'20px'}
        width={`calc(${60 + Math.round(Math.random() * 30)}% - 20px)`}
      />
    </StyledSkeletonFilterItemContainer>
  );
};
